import { render, staticRenderFns } from "./apidel.vue?vue&type=template&id=0573ccb0&scoped=true&"
import script from "./apidel.vue?vue&type=script&lang=js&"
export * from "./apidel.vue?vue&type=script&lang=js&"
import style0 from "./apidel.vue?vue&type=style&index=0&id=0573ccb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0573ccb0",
  null
  
)

export default component.exports